import { render, staticRenderFns } from "./CostBasisRollForwardReport.vue?vue&type=template&id=004e78cb&"
import script from "./CostBasisRollForwardReport.vue?vue&type=script&lang=ts&"
export * from "./CostBasisRollForwardReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports